export enum LinkCategory {
  Misc = 0,
  Immigration = 1,
  Customs = 2,
  Health = 3
}
